var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocialGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 32.2708C55.5725 32.2708 59.6671 33.8467 62.8962 36.9208L71.7441 28.0729C66.3708 23.0742 59.3571 20 51 20C38.8841 20 28.4087 26.9492 23.3066 37.0758L33.6141 45.0712C36.0554 37.7217 42.9141 32.2708 51 32.2708Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6825 51.7104C80.6825 49.6825 80.4887 47.7192 80.1917 45.8333H51V57.4842H67.7142C66.965 61.3075 64.795 64.5625 61.54 66.7583L71.5246 74.5083C77.35 69.1092 80.6825 61.1267 80.6825 51.7104Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6012 56.9288C32.9812 55.0558 32.6196 53.0667 32.6196 51C32.6196 48.9333 32.9683 46.9442 33.6012 45.0713L23.2937 37.0758C21.1883 41.2608 20 45.9883 20 51C20 56.0117 21.1883 60.7392 23.3067 64.9242L33.6012 56.9288Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 82C59.37 82 66.4096 79.2487 71.5246 74.4954L61.54 66.7454C58.7629 68.6183 55.185 69.7163 51 69.7163C42.9142 69.7163 36.0554 64.2654 33.6013 56.9158L23.2938 64.9112C28.4088 75.0508 38.8842 82 51 82Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialGoogle);
export default __webpack_public_path__ + "static/media/ic_social_google.80898808156d68dbd40ca26cfac52330.svg";
export { ForwardRef as ReactComponent };